import { useEffect, useRef } from 'react';

export function useBeforeUnload() {
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);
}

export function useNavigationGuard(onBlock) {
  const onBlockRef = useRef(onBlock);

  useEffect(() => {
    onBlockRef.current = onBlock;
  }, [onBlock]);

  useEffect(() => {
    // Push a duplicate entry so we have something to pop back to
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      // User clicked browser back — push state again to stay on page
      window.history.pushState(null, '', window.location.href);
      onBlockRef.current?.();
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
}